/**
 * MultiSlideBuilder Agent - Suggestions Section
 * 
 * Best practices and suggestions for optimal performance.
 */

import { PromptSectionBase } from '../../../base/systemPrompt/PromptSectionBase';
import { MULTI_SLIDE_BUILDER_PROMPT_KEYS } from './variables';

class MultiSlideBuilderSuggestionsSection extends PromptSectionBase {
    protected readonly keywordsKey = MULTI_SLIDE_BUILDER_PROMPT_KEYS.suggestions;
    protected readonly fallbackContent = `## Suggestions for Best Performance

### Efficient Section Processing

1. **Search strategically**: Use specific, descriptive queries for reference slides
   - Good: "comparison table with financial metrics and growth rates"
   - Bad: "table"
   
2. **Batch research calls**: If multiple slides need similar data, gather it once
   - Combine queries when possible
   - Reuse context IDs across slides in the same section

3. **Define precise areas**: Give ExecutionAgent clear, well-bounded regions
   - Study reference layouts to understand spacing patterns
   - Align areas to the reference slide's structure
   - Specify content type accurately (text, chart, table, mixed)

4. **Handle errors gracefully**: If a section fails, log it and move on
   - Don't retry more than once per section
   - Keep the build progressing rather than getting stuck

### Working with the Style Guide

- **Search before defining areas**: See how similar slides are structured
- **Use layout IDs when available**: Prefer layoutId + documentId over sourceSlideIndex
- **Note density patterns**: Match the information density of reference slides
- **Follow visual hierarchy**: Replicate how reference slides organize space

### Context Management

- **Global context**: Logos, brand colors, shared data → use for all slides
- **Per-slide context**: Specific research, metrics → pass to individual slides
- **Excel context**: Create ranges first, then reference in slides

### Progress Tracking

- Track which sections succeed vs. fail
- Include section summaries in your final submitResults
- Note any skipped sections and why`.trim();
}

const suggestionsSection = new MultiSlideBuilderSuggestionsSection();

/**
 * Get the suggestions section.
 * Uses Keywords AI if available, otherwise falls back to code.
 */
export function getSuggestionsSection(): string {
    return suggestionsSection.getContent();
}

/**
 * Export constant for backwards compatibility
 */
export const MULTI_SLIDE_BUILDER_SUGGESTIONS = suggestionsSection.getFallbackContent();
